import React from 'react';
import type ExternalImportType from '@jira/spa-apps__admin-pages-external-import/src/ExternalImport.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyExternalImport = lazyForPaint<typeof ExternalImportType>(
	() =>
		import(
			/* webpackChunkName: "async-system-external-import", jiraSpaEntry: "async-system-external-import" */ '@jira/spa-apps__admin-pages-external-import/src/ExternalImport.tsx'
		),
	{ ssr: false },
);

const AsyncExternalImport = (): React.JSX.Element => (
	<LazyPage Page={LazyExternalImport} pageId="external-import-general" shouldShowSpinner={false} />
);

export default AsyncExternalImport;
